<div fxLayout="column" class="admin-container" fxLayoutGap="25px">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutGap="20px" fxFlex="70">
            <div>
                <button type="button" class="pending-btn" (click)="sortRequests('Pending')">
                    <div class="pending-request" fxLayoutAlign="start center" fxLayoutGap="10px"
                        [ngClass]="{'cardActive':activeCard == 1}">
                        <img src="assets/pendingRequest1-icon.svg">
                        <span>{{pendingMerchants?.length}}</span><label class="pending-request-label">Total Pending
                            Requests</label>
                    </div>
                </button>
            </div>
            <div>
                <button type="button" class="pending-btn" (click)="sortRequests('Rejected')">
                    <div class="pending-request" fxLayoutAlign="start center" fxLayoutGap="10px"
                        [ngClass]="{'cardActive':activeCard == 2}">
                        <img src="assets/reject-icon.svg">
                        <span>{{rejectMerchants?.length}}</span><label class="pending-request-label">Rejected Requests</label>
                    </div>
                </button>
            </div>
        
        
        </div>
        <div fxLayout="row" class="form-group" fxLayoutAlign="end center">
            <div class="input-icons" fxLayoutAlign="start center">
                <mat-icon class="search-icon" style="position:absolute"><span class="material-symbols-outlined">
                        search
                    </span></mat-icon>
                <input type="search" class="form-control" [(ngModel)]="searchValue" placeholder="Search for merchants  via name or ID" (ngModelChange)="searchMerchants($event)">
            </div>
        </div>
        <span class="example-spacer"></span>
    </div>
    <div>
    
        <div fxLayout="row" fxLayoutAlign="start center">
            <div fxFlex="21" fxFlexOffset="2%" class="admin-header">Merchant Details </div>
            <div fxFlex="22" fxFlexOffset="2%" class="admin-header">Email ID</div>
            <div fxFlex="15" fxFlexOffset="2%" class="admin-header">Status</div>
            <div fxFlex="18" fxFlexOffset="2%" class="admin-header">Created date</div>
        </div>
        <div class="template-list-section" fxLayout="column" fxLayoutAlign="start start">
            <div fxFlex="15" class="template-section" fxLayoutAlign="start center" style="margin-bottom:10px;width: 100%;"
                *ngFor="let merchant of allMerchants">
                <div fxFlex="20" fxFlexOffset="1%" class="admin-header">{{merchant?.name}}</div>
                <div  fxFlex="2"  class="custom-divider"></div>
                <div fxFlex="22" fxFlexOffset="1%" class="admin-header">{{merchant?.email}}</div>
                <div  fxFlex="2"  class="custom-divider"></div>
                <div fxLayout="row" fxFlex="15" fxFlexOffset="1%" class="admin-header">
                    <!-- <div fxLayout="row" fxFlex="20" fxFlexOffset="2%" class="admin-header">{{merchant.status}}</div> -->
                    <div class="pending-status"><span *ngIf="merchant.status == 'PENDING_REVIEW'"> Pending</span>
                    </div>
                    <div class="approved-status"><span *ngIf="merchant.status == 'ACTIVE'">Approved</span></div>
                    <div class="rejected-status"><span *ngIf="merchant.status == 'REJECTED'">Rejected</span></div>
                </div>
                <div  fxFlex="2"  class="custom-divider"></div>
                <div fxFlex="15" fxFlexOffset="1%" style="text-align: center;">
                    <div class="admin-header">{{merchant?.created_at | dateTransform: 'std' }}</div>
                </div>
                <div fxFlex="15" class="admin-header">
                    <button type="button" *ngIf="merchant.status == 'ACTIVE'" class="verify-btn approved-status" fxFlex="40" fxLayoutAlign="center center"
                        style="padding:5px 0;border: 1px solid #00BA34;" (click)="verifyMerchant(merchant)">Verified
                    </button>
                    <button type="button" *ngIf="merchant.status == 'PENDING_REVIEW'" class="verify-btn pending-status" fxFlex="40" fxLayoutAlign="center center"
                        style="padding:5px 0; border: 1px solid #F8B200;" (click)="verifyMerchant(merchant)">Verify
                    </button>
                    <button type="button" *ngIf="merchant.status == 'REJECTED'" class="rejected-status verify-btn" fxFlex="40" fxLayoutAlign="center center"
                        style="padding:5px 0;border: 1px solid #EB5757;" (click)="verifyMerchant(merchant)">Rejected
                    </button>
                </div>
                <div fxFlex="2" fxLayoutAlign="end center">
                    <button type="button" fxLayoutAlign="center center" class="next-btn"
                    routerLink="merchant-dashboard/{{merchant.merchant_id}}/{{merchant.name}}" mat-mini-fab>
                        <mat-icon>
                            <!-- routerLink="/admin/template/{{merchant.merchant_id}}" -->
                            <span class="material-symbols-outlined">
                                chevron_right
                            </span>
                        </mat-icon>
                    </button>
                </div>
            </div>
    
        </div>
    </div>

</div>